var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97778 24V12.7385H0V8.68382H2.97778V5.2206C2.97778 2.49917 4.73676 0 8.78983 0C10.4309 0 11.6443 0.15732 11.6443 0.15732L11.5487 3.9437C11.5487 3.9437 10.3112 3.93166 8.96071 3.93166C7.49911 3.93166 7.26494 4.60522 7.26494 5.72316V8.68382H11.6649L11.4734 12.7385H7.26494V24H2.97778Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ab066dc06289c5672bfceb0dc44b5568.svg";
export { ForwardRef as ReactComponent };